import apiClient from '@/services/apiClient';
import mapper from '@/services/order/mapper';

export default {
	namespaced: true,
	state: {
		openOrders: {
			amount: 0,
			newAmount: 0,
			orders: [],
			ordersSearch: [],
			ordersSearchAmount: 0,
			totalValue: 0,
			sort: 'dateOldNew',
			dateTimeLoaded: null,
		},
		metadata: {
			has_open_bol: false,
			has_open_lightspeed: false,
			has_open_bol_vvb: false,
			has_open_bol_vvv: false,
		}
	},
	getters: {
		amount(state) {
			return state.openOrders.amount;
		},
		newAmount(state) {
			return state.openOrders.newAmount;
		},
		orders(state) {
			return state.openOrders.orders;
		},
	},
	mutations: {
		SET_OPEN_ORDER_AMOUNT(state, amount) {
			state.openOrders.amount = amount;
		},
		SET_OPEN_ORDER_NEW_AMOUNT(state, newAmount) {
			state.openOrders.newAmount = newAmount;
		},
		SET_OPEN_ORDER_ORDERS(state, orders) {
			const ordersMapped = [];
			orders.forEach(order => {
				order = mapper.mapOrder(order);

				ordersMapped.push(order);
			});

			state.openOrders.orders = ordersMapped;
		},
		ADD_OPEN_ORDER_ORDERS(state, orders) {
			//check for dubs and map order
			const newOrders = [];
			orders.forEach(order => {
				order = mapper.mapOrder(order);

				const filteredOrders = state.openOrders.orders.filter(orderFilter => {
					return orderFilter.order.id === order.order.id;
				});

				if (filteredOrders.length === 0) {
					newOrders.push(order);
				}
			});

			state.openOrders.orders = state.openOrders.orders.concat(newOrders);
		},
		SET_OPEN_ORDER_TOTALVALUE(state, totalValue) {
			state.openOrders.totalValue = totalValue;
		},
		REMOVE_OPEN_ORDER_FROM_LIST(state, removedOrder) {
			const newOrders = [];

			state.openOrders.orders.forEach(order => {
				if (order.order.id !== removedOrder.order.id) {
					newOrders.push(order);
				}
			});

			state.openOrders.orders = newOrders;

			//hidden orders shouldn't be counted'
			if(removedOrder.hide === true) return;

			let ordersAmount = state.openOrders.amount;
			ordersAmount--;
			state.openOrders.amount = ordersAmount;

			let totalValue = state.openOrders.totalValue;
			totalValue -= removedOrder.order.order_price;
			state.openOrders.totalValue = totalValue;
		},
		HIDE_OPEN_ORDER_IN_LIST(state, hiddenOrder) {
			const newOrders = [];
			let didChange = false;

			state.openOrders.orders.forEach(order => {
				if (order.order.id === hiddenOrder.order.id) {
					// Only apply counters when the visibility actually changes
					if (!order.hide) {
						let ordersAmount = state.openOrders.amount;
						ordersAmount--;
						state.openOrders.amount = ordersAmount;

						let totalValue = state.openOrders.totalValue;
						totalValue -= hiddenOrder.order.order_price;
						state.openOrders.totalValue = totalValue;
					}

					order.hide = true;
					didChange = true;
				}

				newOrders.push(order);
			});

			// Only replace if we found the order (keeps behavior predictable)
			if (didChange) {
				state.openOrders.orders = newOrders;
			}
		},
		SHOW_OPEN_ORDER_IN_LIST(state, shownOrder) {
			const newOrders = [];
			let didChange = false;

			state.openOrders.orders.forEach(order => {
				if (order.order.id === shownOrder.order.id) {
					// Only apply counters when the visibility actually changes
					if (order.hide) {
						let ordersAmount = state.openOrders.amount;
						ordersAmount++;
						state.openOrders.amount = ordersAmount;

						let totalValue = state.openOrders.totalValue;
						totalValue += shownOrder.order.order_price;
						state.openOrders.totalValue = totalValue;
					}

					order.hide = false;
					didChange = true;
				}

				newOrders.push(order);
			});

			if (didChange) {
				state.openOrders.orders = newOrders;
			}
		},
		UPDATE_OPEN_ORDER_IN_LIST(state, updatedOrder) {
			const newOrders = [];

			updatedOrder = mapper.mapOrder(updatedOrder);

			state.openOrders.orders.forEach(order => {
				if (order.order.id === updatedOrder.order.id) {
					newOrders.push(updatedOrder);
				} else {
					newOrders.push(order)
				}
			});

			state.openOrders.orders = newOrders;
		},
		UPDATE_OPEN_ORDER_IN_SEARCH_LIST(state, updatedOrder) {
			const newOrdersSearch = [];

			updatedOrder = mapper.mapOrder(updatedOrder);

			state.openOrders.ordersSearch.forEach(order => {
				if (order.order.id === updatedOrder.order.id) {
					newOrdersSearch.push(updatedOrder);
				} else {
					newOrdersSearch.push(order)
				}
			});

			state.openOrders.ordersSearch = newOrdersSearch;
		},
		SET_OPEN_ORDER_SEARCH_AMOUNT(state, amount) {
			state.openOrders.ordersSearchAmount = amount;
		},
		RESET_OPEN_ORDER_ORDERS_SEARCH(state) {
			state.openOrders.ordersSearch = [];
			state.openOrders.ordersSearchAmount = 0;
		},
		ADD_OPEN_ORDER_ORDERS_SEARCH(state, orders) {
			//check for dubs
			const newOrders = [];
			orders.forEach(order => {
				order = mapper.mapOrder(order);

				const filteredOrders = state.openOrders.ordersSearch.filter(orderFilter => {
					return orderFilter.order.id === order.order.id;
				});

				if (filteredOrders.length === 0) {
					newOrders.push(order);
				}
			});

			state.openOrders.ordersSearch = state.openOrders.ordersSearch.concat(newOrders);
		},
		REMOVE_OPEN_ORDER_FROM_SEARCH_LIST(state, removedOrder) {
			const newOrdersSearch = [];

			let orderSearchAmount = state.openOrders.ordersSearchAmount;
			state.openOrders.ordersSearch.forEach(order => {
				if (order.order.id !== removedOrder.order.id) {
					newOrdersSearch.push(order);
				} else {
					orderSearchAmount--;
				}
			});

			state.openOrders.ordersSearch = newOrdersSearch;
			state.openOrders.ordersSearchAmount = orderSearchAmount;
		},
		HIDE_OPEN_ORDER_IN_SEARCH_LIST(state, hiddenOrder) {
			const newOrdersSearch = [];
			let didChange = false;

			state.openOrders.ordersSearch.forEach(order => {
				if (order.order.id === hiddenOrder.order.id) {
					order.hide = true;
					didChange = true;
				}

				newOrdersSearch.push(order);
			});

			if (didChange) {
				state.openOrders.ordersSearch = newOrdersSearch;
				let orderSearchAmount = state.openOrders.ordersSearchAmount;
				orderSearchAmount--;
				state.openOrders.ordersSearchAmount = orderSearchAmount;
			}
		},
		SHOW_OPEN_ORDER_IN_SEARCH_LIST(state, shownOrder) {
			const newOrdersSearch = [];
			let didChange = false;

			state.openOrders.ordersSearch.forEach(order => {
				if (order.order.id === shownOrder.order.id) {
					order.hide = false;
					didChange = true;
				}

				newOrdersSearch.push(order);
			});

			if (didChange) {
				state.openOrders.ordersSearch = newOrdersSearch;
				let orderSearchAmount = state.openOrders.ordersSearchAmount;
				orderSearchAmount++;
				state.openOrders.ordersSearchAmount = orderSearchAmount;
			}
		},
		SET_OPEN_ORDER_SORT(state, sort) {
			state.openOrders.sort = sort;
			state.openOrders.orders = [];
			state.openOrders.ordersSearch = [];
			state.openOrders.ordersSearchAmount = 0;
		},
		SET_OPEN_ORDER_DATETIME_LOADED(state, dateTime) {
			state.openOrders.dateTimeLoaded = dateTime;
		},
		SET_METADATA(state, metadata) {
			state.metadata = metadata;
		},
		CLEAR_STORE(state) {
			state.openOrders.amount = 0;
			state.openOrders.newAmount = 0;
			state.openOrders.orders = [];
			state.openOrders.ordersSearch = [];
			state.openOrders.ordersSearchAmount = [];
			state.openOrders.totalValue = 0;
			state.openOrders.sort = 'dateOldNew';
			state.openOrders.dateTimeLoaded = null;
		}
	},
	actions: {
		async init({commit}) {
			return new Promise((resolve, reject) => {
				apiClient.get('orders/get/count').then(response => {
					commit('SET_OPEN_ORDER_AMOUNT', response.data.ordersCount);
					commit('SET_OPEN_ORDER_TOTALVALUE', response.data.totalPrice);
					commit('SET_OPEN_ORDER_DATETIME_LOADED', response.data.dateTime);

					resolve();
				}).catch(err => {
					reject();
				})
			});
		},
		async loadMore({state, commit}, payload) {
			return new Promise((resolve, reject) => {
				if (payload.sort !== state.openOrders.sort) {
					commit('SET_OPEN_ORDER_SORT', payload.sort);
				}

				const filters = payload.filters || ['open'];

				const params = {
					page_size: payload.pageSize,
					page: payload.page,
					sort_by: payload.sort,
					date_time: state.openOrders.dateTimeLoaded,
					filter: filters
				};

				if (payload.type !== null && payload.type !== undefined) {
					params.type = payload.type;
				}

				apiClient.get('orders/get', {params}).then(response => {
					commit('SET_OPEN_ORDER_AMOUNT', response.data.ordersCount);
					commit('SET_OPEN_ORDER_NEW_AMOUNT', response.data.ordersCountAfterDate);
					commit('ADD_OPEN_ORDER_ORDERS', response.data.orders);

					resolve();
				}).catch(err => {
					console.log(err);
					reject();
				})
			});
		},
		async loadMoreSearch({state, commit}, payload) {
			return new Promise((resolve, reject) => {
				const params = {
					page_size: payload.pageSize,
					page: payload.page,
					search: payload.search,
					date_time: state.openOrders.dateTimeLoaded,
					filter: ['open']
				};

				const headers = {
					'content-version': 'v3'
				}

				apiClient.get('orders/get', {params, headers}).then(response => {
					commit('SET_OPEN_ORDER_SEARCH_AMOUNT', response.data.ordersCount);
					commit('SET_OPEN_ORDER_NEW_AMOUNT', response.data.ordersCountAfterDate);
					commit('ADD_OPEN_ORDER_ORDERS_SEARCH', response.data.orders);

					resolve();
				}).catch(err => {
					console.log(err);
					reject();
				})
			});
		},
		async clearSearch({commit}) {
			return new Promise((resolve, reject) => {
				commit('RESET_OPEN_ORDER_ORDERS_SEARCH');

				resolve();
			})
		},
		async updateOrder({commit}, order) {
			return new Promise((resolve, reject) => {
				commit('UPDATE_OPEN_ORDER_IN_LIST', order);
				commit('UPDATE_OPEN_ORDER_IN_SEARCH_LIST', order);
				resolve();
			});
		},
		async removeOrder({commit}, order) {
			return new Promise((resolve, reject) => {
				commit('REMOVE_OPEN_ORDER_FROM_LIST', order);
				commit('REMOVE_OPEN_ORDER_FROM_SEARCH_LIST', order);
				resolve();
			});
		},
		async hideOrder({commit}, order) {
			if(order.hide === true) return Promise.resolve();

			return new Promise((resolve, reject) => {
				commit('HIDE_OPEN_ORDER_IN_LIST', order);
				commit('HIDE_OPEN_ORDER_IN_SEARCH_LIST', order);
				resolve();
			});
		},
		async showOrder({commit}, order) {
			if(order.hide === false) return Promise.resolve();

			return new Promise((resolve, reject) => {
				commit('SHOW_OPEN_ORDER_IN_LIST', order);
				commit('SHOW_OPEN_ORDER_IN_SEARCH_LIST', order);
				resolve();
			});
		},
		async loadMetadata({commit}) {
			return new Promise((resolve, reject) => {
				apiClient.get('orders/get/metadata').then(response => {
					commit('SET_METADATA', response.data);
					resolve();
				}).catch(err => {
					console.log(err);
					reject();
				});
			});
		},
		async clear({commit}) {
			commit('CLEAR_STORE');
		},
	}

}